import Vue from 'vue'
let connect = new Vue()    // 实例
export default connect
